import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import PhoneInput from "react-phone-number-input";
import ReactPixel from 'react-facebook-pixel';
import { useSnackbar } from "react-simple-snackbar";
import Loader from "react-loader-spinner";
import Swal from "sweetalert2";
import demologo from "../../../assets/demologo.png";
import {
  parsePhoneNumber,
  getCountryCallingCode,
  isValidPhoneNumber,
} from "react-phone-number-input";
import { GetAvalableHost, getRandomTeacherForDemo, CreateSession, getAvailableSlot } from "../../../redux/actions/SessionAction";
import { ConfirmDemoPayment } from "../../../redux/actions/UserAction";
import { CreateZoomMeeting } from "../../../redux/actions/ZoomMeeting";
import { useDispatch } from "react-redux";
import { availableDate, TimeValidator, getAvailableTeacherSate, localToutcTimeConverter, slotFormatAMPM, overlapUTCtimeConverter, formatTimeslot } from "../../../helpers/TimeDate";
import razorpayPaymentHelper from "../../../helpers/RazorpayPaymentHelper";
import Loder from "../../loder";
import { getDevice } from "../../../helpers/PageHelper";
import { SignupWithoutOtp } from "../../../redux/actions/AuthAction";
import { initPixel } from "../../../helpers/CampaignEvents";



const DemoScheduleIELTSNewLanding = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const [disabledNumber, setDisabledNumber] = useState(false);
  const [numberOremail, setNumberOrEmail] = useState("");
  const [internationalNumber, setInternationalNumber] = useState("");
  const isTrialClass = JSON.parse(localStorage.getItem("DEMO_SESSION"));
  const [callingCode, setCallingCode] = useState("");
  const time_zone = JSON.parse(localStorage.getItem("TIMEZONE"));
  const setup = JSON.parse(localStorage.getItem("SETUP"));

  const intervaldate = new Date(
    new Date().toLocaleString("en-US", { timeZone: time_zone.timezone })
  );
  //+4
  intervaldate.setHours(intervaldate.getHours() + 2);

  const [loder, setLoder] = useState(false);
  const [getSlotLoder, setGetSlotLoder] = useState(false);
  //DATE
  const [activeDate, setActiveDate] = useState(0);
  const [dateArr, setDateArr] = useState([]);
  const [selectedDate, setSelectedDate] = useState();
  //TIME
  const [timeArr, setTimeArr] = useState([]);
  const [selectedTime, setSelectedTime] = useState();

  const [slotsLimit, setSlotLimit] = useState(8);
  const [paymentLoader, setPaymentLoader] = useState(false);

  //HOST
  // const [hostData, setHostData] = useState();
  //TEACHER
  // const [teacherData, setTeacherData] = useState();
  const user = JSON.parse(localStorage.getItem("DEMOUSER"));
  const token = JSON.parse(localStorage.getItem("TOKEN"));

  const search = useLocation().search;
  const utm_source = new URLSearchParams(search).get('utm_source');
  const utm_medium = new URLSearchParams(search).get('utm_medium');
  const utm_campaign = new URLSearchParams(search).get('utm_campaign');
  console.log(utm_source, utm_medium, utm_campaign);
  const route = window.location.pathname;



  useEffect(() => {
    initPixel()
    ReactPixel.track('PageView')
    ReactPixel.track('Purchase', { currency: "INR", value: 99.00 })
  }, [])


  useEffect(() => {
    if (internationalNumber) {
      const userPhoneNumber = parsePhoneNumber(internationalNumber);

      if (userPhoneNumber) {
        if (isValidPhoneNumber(userPhoneNumber.number)) {
          const country_calling_code = getCountryCallingCode(
            userPhoneNumber.country
          );

          setCallingCode("+" + country_calling_code);
          setNumberOrEmail(
            internationalNumber.replace("+" + country_calling_code, "")
          );
        }
      }
    }
  }, [internationalNumber]);

  const blockTimeSlot = (slot) => {

    const splite = slot.split("-");
    var returnValue;
    console.log(intervaldate.getHours())
    if (getAvailableTeacherSate(new Date()) === getAvailableTeacherSate(selectedDate)) {
      if (intervaldate.getHours() > 9 && intervaldate.getHours() < 24) {

        if (intervaldate.getHours() + ":" + intervaldate.getMinutes() >= splite[1].trim()) {
          returnValue = "remove";
        }
      }
    } else {
      if ("10:00" >= splite[0].trim() || "24:00" <= splite[0].trim()) {
        returnValue = "remove";
      }
    }
    return returnValue;
  };


  useEffect(() => {
    var i = 0;
    var dates = []
    for (i; i < 3; i++) {
      dates.push(availableDate(i))
    }
    setSelectedDate(availableDate(0).date);
    setDateArr(dates)

  }, [])

  useEffect(() => {
    setGetSlotLoder(true)
    const onSuccess = (res) => {
      console.log("get slot success")
      console.log(res);
      setGetSlotLoder(false)
      var timeslotsArray = []
      res.data.teacherSlots?.map(val => {
        if (blockTimeSlot(overlapUTCtimeConverter(val.startTime) + " - " + overlapUTCtimeConverter(val.endTime)) !== "remove") {
          timeslotsArray.push(val)
        }
      })
      setTimeArr(timeslotsArray)
    }
    const onError = (res) => {
      setGetSlotLoder(false)
      console.log("get slot error block")
      // openSnackbar("blockhost error")
      setPaymentLoader(false)
      console.log(res)
    }
    dispatch(
      getAvailableSlot(
        {
          duration: 15,
          sessionType: "Demo",
          sessionDate: getAvailableTeacherSate(selectedDate), 
          subject : "IELTS"
        },

        onSuccess,
        onError
      )
    )
  }, [selectedDate])

  // useEffect(() => {
  //   var timeslotsArray = []

  //   if (getAvailableTeacherSate(intervaldate) === getAvailableTeacherSate(selectedDate)) {
  //     timeInterval.map(val => {

  //     if (blockTimeSlot(val) !== "remove") {

  //       const splite = val.split("-");
  //       var time1 = splite[0].trim() + ":" + "00"
  //       var time2 = splite[1].trim() + ":" + "00"
  //       timeslotsArray.push(...TimeSpliter(time1, time2, 15))
  //     }
  //     })
  //   } else {
  //     timeInterval.map(val => {
  //     const splite = val.split("-");
  //     var time1 = splite[0].trim() + ":" + "00"
  //     var time2 = splite[1].trim() + ":" + "00"
  //     timeslotsArray.push(...TimeSpliter(time1, time2, 15))
  // })
  //   } 
  // setTimeArr(timeslotsArray)
  // }, [selectedDate])
  // console.log(timeArr)

  // console.log(teacherData)
  console.log(selectedDate)
  // const times =selectedTime.split("-");
  console.log(selectedTime)


  //PAYMENT
  const SubscribeClapingo = (e) => {
    e.preventDefault();
    // setSubscribeLoder(true);
    // console.log(amount);
    const userCurrency = time_zone.country === "IN" ? "INR" : "USD";
    const demoAmount = time_zone.country === "IN" ? 99 : 199;
    // const userData = time_zone.timezone;
    // const val = userData.split("/");
    // const calculatedAmount = time_zone.country === "IN" ? amount : amount / 100;
    // console.log(calculatedAmount)


    if (internationalNumber) {
      setPaymentLoader(true)
      //Create account and generate token with number
      const data = {

        phoneNumber: numberOremail,
        isWebsite: true,
        countryCode: callingCode,
        country: time_zone.country,
        timezone: time_zone.timezone,
        source: "web",
        utm_source:decodeURIComponent(utm_source),
        utm_medium:decodeURIComponent(utm_medium),
        utm_campaign:decodeURIComponent(utm_campaign),
        route,
      };
      const onSucess = (tokenres) => {
        // makeToast("success", msg);
        setLoder(false);
        setPaymentLoader(true)
        console.log(tokenres);
        if (tokenres.status == 200 || tokenres.data.learner.isTrialBooked === false) {
          console.log("it works")
          localStorage.setItem("LOGIN", JSON.stringify("true"));
          localStorage.setItem("ROLE", JSON.stringify("Learner"));
          localStorage.setItem("IS_LOGOUT", true);
          localStorage.setItem("LOGIN", JSON.stringify("true"));
          localStorage.setItem("ROLE", JSON.stringify("Learner"));
          localStorage.setItem("DEMOUSER", JSON.stringify(tokenres.data.learner));
          localStorage.setItem("TOKEN", JSON.stringify(tokenres.data.learner.token));
          localStorage.setItem("IS_LOGOUT", true);
          localStorage.removeItem("STEP");
          localStorage.removeItem("DATA");
          localStorage.removeItem("NAME");
          // openSnackbar("successful");

          // history.replace({ pathname: '/google/book-demo/schedule-demo' });
          // window.location.reload();

            //confirm demo payment API call
          var demopayedData = {
            transactionId: "wordpress payment",
            learnerId: tokenres.data.learner._id
          }
          var demoPayed = (res) => {
            // setDemoLoder(false);
            console.log("demo payed success");
            console.log(res);
            localStorage.setItem("DEMO_SESSION", true);
            // setPaymentSuccess(true)

            // if (isAddPage === true || isAddPage === "true") {
            //   localStorage.removeItem("ADD_PAGE")
            //   ReactPixel.track("Start trial", { "Adult website": true });
            //   localStorage.setItem("ADD_PAGE_USER", true);
            // }
          }
          var demoFailed = (errmsg) => {
            // setDemoLoder(false);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: errmsg,
            });
          }
          dispatch(ConfirmDemoPayment(demopayedData, demoPayed, demoFailed, tokenres.data.learner.token))


          //Get Random Teacher API call

          const getRandomTeacherSuccess = (res) => {
            setPaymentLoader(true)
            console.log("get available random teacher successfully called")
            // setTeacherData(res.teacher);
            const teacherData = res.teacher;
            const blockHostSuccess = (res, res2) => {
              setPaymentLoader(true)
              console.log("blockhost on success block");
              const hostData = res;
              const hostId = res2;

              //create meeting
              // get available host & call createMeeting


              const maindata = {
                userId: hostData, //hostdata is email from block host api call
                data: {
                  topic: "Clapingo Demo Session",
                  type: 2,
                  start_time: selectedTime.startTime,
                  duration: 15,
                  schedule_for: hostData,
                  timezone: "UTC",
                  password: "clapingo",
                  agenda: "Learn English",
                  settings: {
                    host_video: true,
                    participant_video: true,
                    cn_meeting: false,
                    in_meeting: true,
                    join_before_host: true,
                    mute_upon_entry: true,
                    watermark: false,
                    use_pmi: false,
                    approval_type: 2,
                    auto_recording: "cloud",
                    registrants_email_notification: true,
                  },
                },
              };

              const onSuccess = (data) => {
                setPaymentLoader(true)
                console.log("create zoom meeting onsuccess called")
                if (teacherData) {
                  if (data) {
                    var meetingndata = {
                      meetingNo: String(data.id),

                      learner: tokenres.data.learner._id, //learnerid from tokenres

                      teacher_: teacherData.teacher, //teacherid
                      startTime: selectedTime.startTime,
                      endTime: selectedTime.endTime,
                      sessionDate: getAvailableTeacherSate(selectedDate?.toUTCString()),
                      meetingPassword: data.password,
                      startMeetingUrl: data.start_url,
                      joinMeetingUrl: data.join_url,
                      host: data.host_email,
                      isAdmin: false,
                      isWebsite: true,
                      blockHostId: hostId,//blockhost api call id
                      timezone: time_zone.timezone,
                      isTimeUtc: true,
                      subject:"IELTS",
                      source: getDevice()
                    };

                    meetingndata["type"] = "Demo";
                    meetingndata["sessionDuration"] = "15min";


                    const onSuccess = () => {
                      setPaymentLoader(false)
                      console.log("create clapingo meeting onsuccess called");
                      setLoder(false);

                      if (

                        (tokenres.data.learner.isTrialBooked === false &&
                          tokenres.data.learner.isDemoPayed === true) ||

                        isTrialClass
                      ) {
                        localStorage.setItem("DEMO_BOOKED", JSON.stringify(true));
                        localStorage.setItem("DEMO_TIME", JSON.stringify(selectedTime));
                        // localStorage.setItem("DEMO_DATE", JSON.stringify(selectedDate));
                        localStorage.setItem("DEMO_DATE", JSON.stringify(getAvailableTeacherSate(selectedDate)));
                        localStorage.removeItem("DEMO_SESSION");
                        setLoder(false);

                        history.replace({ pathname: '/thankyou/ielts/book-demo/success' });

                        Swal.fire("Demo Booked Successfully!", "", "success");
                        // window.location.reload();
                      } else {
                        Swal.fire("Session Booked Successfully!", "", "success");
                        localStorage.setItem("DEMO_TIME", JSON.stringify(selectedTime));
                        // localStorage.setItem("DEMO_DATE", JSON.stringify(selectedDate));
                        localStorage.setItem("DEMO_DATE", JSON.stringify(getAvailableTeacherSate(selectedDate)));

                        history.replace({ pathname: '/thankyou/ielts/book-demo/success' });

                        // window.location.reload();
                      }
                    };
                    const onError = (err) => {
                      openSnackbar("create meeting error")
                      setPaymentLoader(false)
                      console.log(err)
                      setLoder(false);
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: err,
                      });
                    };

                    dispatch(CreateSession(meetingndata, onSuccess, onError, tokenres.data.learner.token));

                  } else {
                    setLoder(false);
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Unable to book meeting due to some technical reason please try again later",
                    });
                  }
                }
                else {
                  setLoder(false);
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Teacher data not available",
                  });
                }
              };
              const onError = () => {
                setLoder(false);
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Oops something went wrong !!",
                });
              };
              dispatch(CreateZoomMeeting(maindata, onSuccess, onError));
            }
            const blockHostError = (res) => {
              setLoder(false)
              setPaymentLoader(false)
              console.log("blockhost error block")
              openSnackbar("blockhost error")
              console.log(res)
            }
            dispatch(
              GetAvalableHost(
                {
                  startTime: selectedTime.startTime,
                  endTime: selectedTime.endTime,
                  sessionDate: getAvailableTeacherSate(selectedDate),
                  isTimeUtc: true,
                },

                blockHostSuccess,
                blockHostError,

                tokenres.data.learner.token

              )
            );
          }
          const getRandomTeacherError = (res) => {
            console.log("get available teacher error block");
            openSnackbar("Book teacher error/Teacher not available at that time")
            console.log(res)
            setPaymentLoader(false)
          }

          dispatch(
            getRandomTeacherForDemo(
              {
                // sessionTime: TimeValidator(localToutcTimeConverter(selectedTime.start)),  
                subject:"IELTS",  
                sessionTime: selectedTime.startTime,
                sessionEndTime: selectedTime.endTime,
                sessionDate: getAvailableTeacherSate(selectedDate),

              },
              getRandomTeacherSuccess,
              getRandomTeacherError,

              tokenres.data.learner.token
            )
          );

        }

        else if (tokenres.status == 201 && tokenres.data.learner.isTrialBooked === true) {
          console.log("user exist")
          setPaymentLoader(false)
          openSnackbar('This number is registered, try another number')

          // console.log(res)
          // setStatusCode(res.status);
          // setIswhatsapp(res.data.learner.isWhatsappNumber);
          // setIsnumber(res.data.learner.phoneNumber);
          // setIsemail(res.data.learner.email);

          // openSnackbar("User already exist. Please Login");
          // history.push("/login");

        }

      };
      const onError = (res) => {
        //   setField("password");
        setLoder(false);
        setPaymentLoader(false)
        // setErrmsg(res);
        openSnackbar("Enter a valid number")
        console.log(res)
      };
      dispatch(SignupWithoutOtp(data, onSucess, onError));



    } else {
      setPaymentLoader(false)
      openSnackbar("Please enter the number")
    }




  };



  // const modalClose = () => {
  //   // setSubscribeLoder(false);
  // };

  ;


  return (
    <div>
      { }
      {paymentLoader ?
        <div>

          <h6 className="text-center">Processing</h6>

          <div className="text-center">
            <Loader type="Grid" color="#00BFFF" height={80} width={80} />
          </div>
        </div> :
        <form onSubmit={(e) => SubscribeClapingo(e)}>
          <div className="demo-form">
          <p style={{color:"green", marginBottom:"0px"}}>Congratulations 🥳, your Demo payment is complete. </p>
            <p style={{color:"green", fontWeight:"bold", marginBottom:"0px"}}>You can now select your slot for your demo class. And we will send the details to the registered number</p>
            <div className=" mt-3">
              <label>
                <div className="mb-2">
                  <img
                    width="122px"
                    height="32px"
                    src={demologo}
                    alt="clapingologo"
                  />
                </div>

                <p className="subtitleA mt-2">Enter the number used for payment</p>

                <PhoneInput
                  placeholder="Enter Mobile number"
                  className="form-control RegInput d-flex mb-3"
                  international
                  countryCallingCodeEditable={false}
                  defaultCountry={time_zone.country}
                  // country={time_zone.country}
                  value={internationalNumber}
                  onChange={setInternationalNumber}
                  disabled={disabledNumber}
                  required

                />


              </label>
              <div>
                <p className="subtitleA mt-2">Select a date</p>
                <div>
                  {dateArr.map((data, i) => (
                    <button
                      type="button"
                      onClick={() => {
                        setActiveDate(i)
                        setSelectedDate(data.date)
                        setSlotLimit(8)
                        setSelectedTime("")
                      }}
                      className={`dateBTN  mr-md-3 mr-2 ${i === activeDate ? "active-date" : ""}`}
                      key={i}
                    >
                      <span style={{ color: "#139980" }}>{data.dateNo} {data.weekDay}</span>
                      <br />
                      {data.month}
                    </button>
                  ))}
                </div>
              </div>
              <div>
                <p className="subtitleA mt-4">Select a Time slot</p>
                {
                  getSlotLoder ? <Loder /> :
                    <div className="d-flex flex-wrap">

                      {
                        timeArr.slice(0, slotsLimit).map((val, i) => {
                          return <button type="button" className={`timeBTN m-1 ${selectedTime?.startTime === val.startTime ? "active-time" : ""}`} onClick={() => setSelectedTime(val)} key={i}>{slotFormatAMPM(`${overlapUTCtimeConverter(val.startTime)} - ${overlapUTCtimeConverter(val.endTime)}`)}</button>
                        })
                      }
                      {
                        slotsLimit !== timeArr.length ?
                          <button className="timeBTN  m-1" type="button" onClick={() => setSlotLimit(slotsLimit + 8)}>View more</button>
                          : ""
                      }

                    </div>
                }

              </div>

              <button
                // onClick={() => history.replace({ pathname: "success" })}
                // onClick={(e)=>SubscribeClapingo}
                type="submit"
                disabled={loder || !selectedTime ? true : false}
                className={
                  loder
                    ? "continueBTNdisabled btn-block mx-auto"
                    : "continueBTN  btn-block mx-auto"
                }
              >
                {loder ? "Loading ..." : "Book Demo"}
              </button>

            </div>
          </div>
        </form>
      }
    </div>
  );
};

export default DemoScheduleIELTSNewLanding;